mutation setSupportImpersonation($input: SetSupportImpersonationInput!) {
  setSupportImpersonation(input: $input)
}
